export const Logo = ({ light = false, className = "" }) => {
  const main = light ? "#FFFFFF" : "#1B2A41";
  return (
    <span className={`inline-flex items-center gap-3 ${className}`} data-testid="site-logo">
      <svg width="44" height="44" viewBox="0 0 72 72" aria-hidden="true">
        <path d="M14 36a22 22 0 1 1 44 0" fill="none" stroke={main} strokeWidth="5" strokeLinecap="round" />
        <path d="M58 36a22 22 0 0 1-11 19" fill="none" stroke="#E8730C" strokeWidth="5" strokeLinecap="round" />
        <line x1="6" y1="36" x2="66" y2="36" stroke="#E8730C" strokeWidth="3" strokeLinecap="round" />
        <circle cx="36" cy="36" r="4.5" fill="#E8730C" />
      </svg>
      <span className="flex flex-col leading-none">
        <span className={`font-heading font-extrabold text-2xl tracking-wide ${light ? "text-white" : "text-slate"}`}>
          O'RIZON <span className="text-copper">360</span>
        </span>
        <span className={`text-[9px] font-semibold tracking-[0.22em] uppercase mt-1 ${light ? "text-white/60" : "text-muted"}`}>
          Rénovation · Entretien d'immeubles
        </span>
      </span>
    </span>
  );
};
